
import * as RecommendationNotificationComponent from "./recommendationNotification.component";

declare const angular;
export const RECOMMENDATIONS_MODULE = angular.module("AccountApp.v2.Components.Recommendations", []);


RECOMMENDATIONS_MODULE.component(RecommendationNotificationComponent.NAME, RecommendationNotificationComponent.OPTIONS);
